<template>
  <el-row>
    <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png" />
        <span style="font-size:20px;">新增服务人员信息</span>
    </div>
    <el-form  ref="addPeopleForm" :model="addPeopleForm" :rules="addPeopleFormRules" label-width="160px">
      <el-col :span="12">
      <el-form-item label="姓名:" prop="userName">
        <el-input
          v-model.trim="addPeopleForm.userName"
          placeholder="请输入姓名"
          maxlength="14"
          style="width:220px;"
        ></el-input>
        <i class="el-icon-circle-close"></i>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="登录名:" prop="loginName">
        <el-input
          v-model.trim="addPeopleForm.loginName"
          placeholder="请输入登录名"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>

    <el-col :span="12">
      <el-form-item label="身份证号:" prop="idCard">
        <el-input
          v-model.trim="addPeopleForm.idCard"
          placeholder="请输入身份证号"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>

    <el-col :span="12">
      <el-form-item label="联系方式:" prop="mobileNo">
        <el-input
          v-model.trim="addPeopleForm.mobileNo"
          placeholder="请输入联系方式"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="民族:" prop="nation">
        <el-input
          v-model.trim="addPeopleForm.nation"
          placeholder="请选择民族"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="学历:" prop="education">
        <el-input
          v-model.trim="addPeopleForm.education"
          placeholder="请输入学历"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
<el-col :span="12">
      <el-form-item label="职业类型:" prop="jobType">
        <el-input
          v-model.trim="addPeopleForm.jobType"
          placeholder="请输入职业类型"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="地址:" prop="address">
        <el-input
          v-model.trim="addPeopleForm.address"
          placeholder="请输入地址"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="技能:" prop="skill">
        <el-input
          v-model.trim="addPeopleForm.skill"
          placeholder="请输入技能"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
<el-col :span="12">
      <el-form-item label="省:" prop="sheng">
        <el-input
          v-model.trim="addPeopleForm.sheng"
          placeholder="请输入"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
<el-col :span="12">
      <el-form-item label="市:" prop="shi">
        <el-input
          v-model.trim="addPeopleForm.shi"
          placeholder="请输入"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
<el-col :span="12">
      <el-form-item label="区:" prop="qu">
        <el-input
          v-model.trim="addPeopleForm.qu"
          placeholder="请输入"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
<el-col :span="12">
      <el-form-item label="街道" prop="jiedao">
        <el-input
          v-model.trim="addPeopleForm.jiedao"
          placeholder="请输入"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="社区" prop="shequ">
        <el-input
          v-model.trim="addPeopleForm.shequ"
          placeholder="请输入"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
 <el-col :span="12">
      <el-form-item label="详细地址" prop="address">
        <el-input
          v-model.trim="addPeopleForm.address"
          placeholder="请输入"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
     <el-col :span="12">
      <el-form-item label="服务站" prop="serviceAddress">
        <el-input
          v-model.trim="addPeopleForm.serviceAddress"
          placeholder="请输入"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="员工编号" prop="userNo">
        <el-input
          v-model.trim="addPeopleForm.userNo"
          placeholder="请输入"
          maxlength="14"
          style="width:220px;"
        ></el-input>
      </el-form-item>
    </el-col>
    <el-col>
      <el-form-item label="照片上传" prop="userNo">
        <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-col>
    <el-col>
      <el-form-item style="margin-left:30%">
        <el-button type="primary" @click="submitPeopleAddFun">确定</el-button>
        <el-button @click="backOldList">取消</el-button>
      </el-form-item>
    </el-col>
    </el-form>
  </el-row>
</template>
<script>
import bus from '@/vuex/eventBus'//引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      addPeopleForm:{},
      addPeopleFormRules:{},

    };
  },
  methods:{
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },

      backOldList() {
        bus.$emit('close_current_tags');
      },

  }
};
</script>